import * as React from 'react'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles, Spinner } from '@fluentui/react-components'
import { SpinnerProps } from '@fluentui/react-spinner'

const useStyles = makeStyles({
    root: { height: '100%', alignContent: 'center' },
})

const Loading: FunctionComponent<SpinnerProps> = props => {
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <div className={styles.root}>
            <Spinner size={'small'} labelPosition={'before'} label={translate('base.loading')} {...props} />
        </div>
    )
}

export default Loading
